import ReactPixel from "react-facebook-pixel";

const pixelId = import.meta.env.VITE_PIXEL_ID;

const options = {
  autoConfig: true,
  debug: false, // خليها true لو عايز تشوف اللوجات
};

export const initFacebookPixel = () => {
  ReactPixel.init(pixelId, options);
  ReactPixel.pageView();
};
